import { render, staticRenderFns } from "./FrameworkImportView.vue?vue&type=template&id=4f4b5c2f&"
import script from "./FrameworkImportView.vue?vue&type=script&lang=ts&"
export * from "./FrameworkImportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports